import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Flex } from 'Components/Base';
import Selectable from 'Components/Selectable';

const ReviewSelection = ({
  answerableCount = 1,
  choices = [],
  value = [],
  onChange = () => {},
  selectProps,
  ...props
}) => {
  const [answerList, setAnswerList] = useState(value);

  const handleSelectableClick = (e) => {
    const newValue = e.target.value;

    if (answerableCount === 1) {
      setAnswerList([newValue]);
      onChange([newValue]);
    } else {
      if (answerList.includes(newValue)) {
        const newAnswerList = [...answerList.filter((value) => value !== newValue)];

        setAnswerList(newAnswerList);
        onChange(newAnswerList);
      } else {
        let newAnswerList = [...answerList, newValue];

        if (newAnswerList.length >= answerableCount) {
          newAnswerList.splice(0, newAnswerList.length - answerableCount);
        }

        setAnswerList(newAnswerList);
        onChange(newAnswerList);
      }
    }
  };

  return (
    <Flex flexWrap={'wrap'} {...props}>
      {choices.map((choice, index) => (
        <Selectable
          key={index}
          name={'choice'}
          value={choice?.value}
          label={choice?.label}
          checked={answerList.includes(choice?.value)}
          onChange={handleSelectableClick}
          {...selectProps}
        />
      ))}
    </Flex>
  );
};

ReviewSelection.propTypes = {
  choices: PropTypes.array,
  answerableCount: PropTypes.number,
  value: PropTypes.array,
  onChange: PropTypes.func,
  selectProps: PropTypes.object,
};

export default ReviewSelection;
